import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import WorkspaceOrganizationMemberAppResource from './WorkspaceOrganizationMemberAppResource';
import FormAppResource from "./FormAppResource";
import ResourceAppResource from "./ResourceAppResource";
import WorkspaceAppResource from "./WorkspaceAppResource";
import FileAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/FileAppResource";
import Engine from "@milestoneslabs/milestones-js-engine/src/Engine";

class JotFormResourceSessionAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'jot-form-resource-session';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'jots/forms/resources/sessions';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'submissionId',
            'formUuid',
            'resourceUuid',
            'projectUuid',
            'projectMemberUuid',
            'updatedAt',
            'files',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            form: FormAppResource,
            resource: ResourceAppResource,
            project: WorkspaceAppResource,
            projectMember: WorkspaceOrganizationMemberAppResource,
            files: FileAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            form: 'form_uuid',
            resource: 'resource_uuid',
            project: 'project_uuid',
            projectMember: 'project_member_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            submissionId: {
                type: 'string',
            },
            formUuid: {
                type: 'string',
                presence: true,
            },
            resourceUuid: {
                type: 'string',
                presence: true,
            },
            projectUuid: {
                type: 'string',
                presence: true,
            },
            projectMemberUuid: {
                type: 'string',
                presence: true,
            },
            updatedAt: {
                datetime: true,
            },
        };
    }

    apiPaths () {
        return {
            ...super.apiPaths(),
            'sign': Engine.apiUrl(this.appResourceApiPrefix() + '/{uuid}/sign'),
        }
    }

    async sign(data) {
        const url = this.apiPaths().sign.replace('{uuid}', this.uuid);

        return await Engine.post(url, {
            ...data,
        });
    }
}

export default JotFormResourceSessionAppResource;
